module.exports = __webpack_public_path__ + "static/media/1021851.6d539a51.jpg";